// Utilitarios do download em segundo plano: situacoes, progresso e textos exibidos ao usuario.

export const SITUACAO_DOWNLOAD = Object.freeze({
    NA_FILA: 'fila',
    GERANDO: 'gerando',
    BAIXANDO: 'baixando',
    CONCLUIDO: 'concluido',
    ERRO: 'erro'
});

export const MENSAGEM_ERRO_PADRAO = 'Não foi possível gerar o arquivo. Tente novamente.';

export function emAndamento(situacao) {
    return situacao === SITUACAO_DOWNLOAD.GERANDO || situacao === SITUACAO_DOWNLOAD.BAIXANDO;
}

export function ativo(situacao) {
    return situacao === SITUACAO_DOWNLOAD.NA_FILA || emAndamento(situacao);
}

export function progressoDoEvento(evento) {
    if (evento && evento.lengthComputable !== false && evento.total > 0) {
        return Math.min(100, Math.round(evento.loaded * 100 / evento.total));
    }
    return null;
}

export function textoSituacao(download) {
    const { situacao, progresso, nomeArquivo, mensagemErro } = download;

    switch (situacao) {
        case SITUACAO_DOWNLOAD.NA_FILA:
            return 'Na fila';
        case SITUACAO_DOWNLOAD.GERANDO:
            return 'Gerando o arquivo...';
        case SITUACAO_DOWNLOAD.BAIXANDO:
            return progresso == null ? 'Baixando...' : `Baixando... ${progresso}%`;
        case SITUACAO_DOWNLOAD.CONCLUIDO:
            return `Concluído: ${nomeArquivo}`;
        case SITUACAO_DOWNLOAD.ERRO:
            return mensagemErro || MENSAGEM_ERRO_PADRAO;
        default:
            return '';
    }
}

export function textoResumo(downloads) {
    if (!downloads || downloads.length === 0) {
        return '';
    }

    const n = downloads.filter((d) => ativo(d.situacao)).length;
    if (n > 0) {
        return n === 1 ? '1 arquivo em download' : `${n} arquivos em download`;
    }

    const e = downloads.filter((d) => d.situacao === SITUACAO_DOWNLOAD.ERRO).length;
    if (e > 0) {
        return e === 1 ? '1 download com erro' : `${e} downloads com erro`;
    }

    const c = downloads.filter((d) => d.situacao === SITUACAO_DOWNLOAD.CONCLUIDO).length;
    return c === 1 ? '1 download concluído' : `${c} downloads concluídos`;
}

export function progressoGeral(downloads) {
    const andamento = (downloads || []).filter((d) => emAndamento(d.situacao));
    if (andamento.length === 0 || andamento.some((d) => d.progresso == null)) {
        return null;
    }

    const soma = andamento.reduce((total, d) => total + d.progresso, 0);
    return Math.round(soma / andamento.length);
}

export function textoAviso(titulo, naFila = false) {
    if (naFila) {
        return `O download de "${titulo}" entrou na fila e vai ocorrer em segundo plano. Você pode continuar usando o sistema e acompanhar o andamento no canto inferior direito da tela.`;
    }
    return `O download de "${titulo}" vai ocorrer em segundo plano. Você pode continuar usando o sistema e acompanhar o andamento no canto inferior direito da tela.`;
}
